import { default as AwarenessOpportunitiesList } from './AwarenessOpportunitiesList';

export default AwarenessOpportunitiesList;
